import { Component, OnInit } from '@angular/core';
import { IdleService } from './Core/services/idle.service';
import { LanguageService } from './Core/services/language.service';
import { NavigationStart, Router } from '@angular/router';
import Adjust from '@adjustcom/adjust-web-sdk';
import { environment } from 'src/environments/environment';
import { SessionService } from './Core/services/session.service';

declare function InitiateLogRocket(en : any, newSession : boolean): void;
const Adjust_APP_TOKEN = 'xmmu4c2wsl4w';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  modalState = false;
  timer: any;
  initialLoad = false;
  message: any = null;
  ngAfterViewInit(): void {} 
  expiryTime = environment.production ? 180 : 180000; //TIME IN SECONDES 
  timerRemaining: number = 30;
  constructor( private languageService: LanguageService, private idle: IdleService, private router: Router, private session: SessionService) {
    InitiateLogRocket(environment, false);
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate' && (event.url?.split('?')[0] === '/application-engine/landing-page' || event.url?.split('?')[0] === '/application-engine')) 
        {
          if (sessionStorage.getItem('mobile')) 
            (window as any).exitWebView();
          else
            this.router.navigate(['dash']);
        }
      }
    });

    this.languageService.initLanguage();

    if (!sessionStorage.getItem('IframOrigin')) {
      this.idle.startTimer(this.expiryTime);
      this.idle.showIdleModal$.subscribe((val) => {
        if (val)
          this.showIdleModal();
        else
          this.hideIdleModal();
      });
    }

    console.log('Adjust SDK initialized with token');
    Adjust.initSdk({
      appToken: Adjust_APP_TOKEN,
      environment: environment.production ? 'production' : 'sandbox',
      logLevel: environment.production ? 'none' : 'verbose',
    });

    Adjust.waitForWebUUID().then((uuid) => {
      console.log('Adjust Web UUID:', uuid);
      if (this.session.runPlatform === 'web') return;
      sessionStorage.setItem('adid', uuid);
    });
  }

  showIdleModal() {
    this.modalState = true;
    this.startTimer();
  }

  hideIdleModal() {
    clearInterval(this.timer);
    this.modalState = false;
  }

  startTimer() {
    this.timerRemaining = 30;
    this.timer = setInterval(() => {
      if (--this.timerRemaining == 0) {
        clearInterval(this.timer);
        this.idle.signOut();
      }
    }, 1000);
  }
}
